import _createForOfIteratorHelper from "/root/Etro/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import React from 'react';
import { IconItalic, IconUnderline, IconStrikethrough, IconClearFormatting, IconUnlink, IconList, IconListNumbers, IconH1, IconH2, IconH3, IconH4, IconH5, IconH6, IconBlockquote, IconAlignLeft, IconAlignRight, IconAlignCenter, IconAlignJustified, IconSubscript, IconSuperscript, IconCode, IconHighlight, IconLineDashed, IconCircleOff, IconBold } from '@tabler/icons-react';
import { createControl } from './ControlBase/create-control.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var BoldControl = createControl({
  label: "boldControlLabel",
  icon: function icon(props) {
    return /* @__PURE__ */React.createElement(IconBold, __spreadProps(__spreadValues({}, props), {
      stroke: 1.5
    }));
  },
  isActive: {
    name: "bold"
  },
  operation: {
    name: "toggleBold"
  }
});
var ItalicControl = createControl({
  label: "italicControlLabel",
  icon: function icon(props) {
    return /* @__PURE__ */React.createElement(IconItalic, __spreadProps(__spreadValues({}, props), {
      stroke: 1.5
    }));
  },
  isActive: {
    name: "italic"
  },
  operation: {
    name: "toggleItalic"
  }
});
var UnderlineControl = createControl({
  label: "underlineControlLabel",
  icon: function icon(props) {
    return /* @__PURE__ */React.createElement(IconUnderline, __spreadProps(__spreadValues({}, props), {
      stroke: 1.5
    }));
  },
  isActive: {
    name: "underline"
  },
  operation: {
    name: "toggleUnderline"
  }
});
var StrikeThroughControl = createControl({
  label: "strikeControlLabel",
  icon: function icon(props) {
    return /* @__PURE__ */React.createElement(IconStrikethrough, __spreadProps(__spreadValues({}, props), {
      stroke: 1.5
    }));
  },
  isActive: {
    name: "strike"
  },
  operation: {
    name: "toggleStrike"
  }
});
var ClearFormattingControl = createControl({
  label: "clearFormattingControlLabel",
  icon: function icon(props) {
    return /* @__PURE__ */React.createElement(IconClearFormatting, __spreadProps(__spreadValues({}, props), {
      stroke: 1.5
    }));
  },
  operation: {
    name: "unsetAllMarks"
  }
});
var UnlinkControl = createControl({
  label: "unlinkControlLabel",
  icon: function icon(props) {
    return /* @__PURE__ */React.createElement(IconUnlink, __spreadProps(__spreadValues({}, props), {
      stroke: 1.5
    }));
  },
  operation: {
    name: "unsetLink"
  }
});
var BulletListControl = createControl({
  label: "bulletListControlLabel",
  icon: function icon(props) {
    return /* @__PURE__ */React.createElement(IconList, __spreadProps(__spreadValues({}, props), {
      stroke: 1.5
    }));
  },
  isActive: {
    name: "bulletList"
  },
  operation: {
    name: "toggleBulletList"
  }
});
var OrderedListControl = createControl({
  label: "orderedListControlLabel",
  icon: function icon(props) {
    return /* @__PURE__ */React.createElement(IconListNumbers, __spreadProps(__spreadValues({}, props), {
      stroke: 1.5
    }));
  },
  isActive: {
    name: "orderedList"
  },
  operation: {
    name: "toggleOrderedList"
  }
});
var H1Control = createControl({
  label: "h1ControlLabel",
  icon: function icon(props) {
    return /* @__PURE__ */React.createElement(IconH1, __spreadProps(__spreadValues({}, props), {
      stroke: 1.5
    }));
  },
  isActive: {
    name: "heading",
    attributes: {
      level: 1
    }
  },
  operation: {
    name: "toggleHeading",
    attributes: {
      level: 1
    }
  }
});
var H2Control = createControl({
  label: "h2ControlLabel",
  icon: function icon(props) {
    return /* @__PURE__ */React.createElement(IconH2, __spreadProps(__spreadValues({}, props), {
      stroke: 1.5
    }));
  },
  isActive: {
    name: "heading",
    attributes: {
      level: 2
    }
  },
  operation: {
    name: "toggleHeading",
    attributes: {
      level: 2
    }
  }
});
var H3Control = createControl({
  label: "h3ControlLabel",
  icon: function icon(props) {
    return /* @__PURE__ */React.createElement(IconH3, __spreadProps(__spreadValues({}, props), {
      stroke: 1.5
    }));
  },
  isActive: {
    name: "heading",
    attributes: {
      level: 3
    }
  },
  operation: {
    name: "toggleHeading",
    attributes: {
      level: 3
    }
  }
});
var H4Control = createControl({
  label: "h4ControlLabel",
  icon: function icon(props) {
    return /* @__PURE__ */React.createElement(IconH4, __spreadProps(__spreadValues({}, props), {
      stroke: 1.5
    }));
  },
  isActive: {
    name: "heading",
    attributes: {
      level: 4
    }
  },
  operation: {
    name: "toggleHeading",
    attributes: {
      level: 4
    }
  }
});
var H5Control = createControl({
  label: "h5ControlLabel",
  icon: function icon(props) {
    return /* @__PURE__ */React.createElement(IconH5, __spreadProps(__spreadValues({}, props), {
      stroke: 1.5
    }));
  },
  isActive: {
    name: "heading",
    attributes: {
      level: 5
    }
  },
  operation: {
    name: "toggleHeading",
    attributes: {
      level: 5
    }
  }
});
var H6Control = createControl({
  label: "h6ControlLabel",
  icon: function icon(props) {
    return /* @__PURE__ */React.createElement(IconH6, __spreadProps(__spreadValues({}, props), {
      stroke: 1.5
    }));
  },
  isActive: {
    name: "heading",
    attributes: {
      level: 6
    }
  },
  operation: {
    name: "toggleHeading",
    attributes: {
      level: 6
    }
  }
});
var BlockquoteControl = createControl({
  label: "blockquoteControlLabel",
  icon: function icon(props) {
    return /* @__PURE__ */React.createElement(IconBlockquote, __spreadProps(__spreadValues({}, props), {
      stroke: 1.5
    }));
  },
  isActive: {
    name: "blockquote"
  },
  operation: {
    name: "toggleBlockquote"
  }
});
var AlignLeftControl = createControl({
  label: "alignLeftControlLabel",
  icon: function icon(props) {
    return /* @__PURE__ */React.createElement(IconAlignLeft, __spreadProps(__spreadValues({}, props), {
      stroke: 1.5
    }));
  },
  operation: {
    name: "setTextAlign",
    attributes: "left"
  }
});
var AlignRightControl = createControl({
  label: "alignRightControlLabel",
  icon: function icon(props) {
    return /* @__PURE__ */React.createElement(IconAlignRight, __spreadProps(__spreadValues({}, props), {
      stroke: 1.5
    }));
  },
  operation: {
    name: "setTextAlign",
    attributes: "right"
  }
});
var AlignCenterControl = createControl({
  label: "alignCenterControlLabel",
  icon: function icon(props) {
    return /* @__PURE__ */React.createElement(IconAlignCenter, __spreadProps(__spreadValues({}, props), {
      stroke: 1.5
    }));
  },
  operation: {
    name: "setTextAlign",
    attributes: "center"
  }
});
var AlignJustifyControl = createControl({
  label: "alignJustifyControlLabel",
  icon: function icon(props) {
    return /* @__PURE__ */React.createElement(IconAlignJustified, __spreadProps(__spreadValues({}, props), {
      stroke: 1.5
    }));
  },
  operation: {
    name: "setTextAlign",
    attributes: "justify"
  }
});
var SubscriptControl = createControl({
  label: "subscriptControlLabel",
  icon: function icon(props) {
    return /* @__PURE__ */React.createElement(IconSubscript, __spreadProps(__spreadValues({}, props), {
      stroke: 1.5
    }));
  },
  isActive: {
    name: "subscript"
  },
  operation: {
    name: "toggleSubscript"
  }
});
var SuperscriptControl = createControl({
  label: "superscriptControlLabel",
  icon: function icon(props) {
    return /* @__PURE__ */React.createElement(IconSuperscript, __spreadProps(__spreadValues({}, props), {
      stroke: 1.5
    }));
  },
  isActive: {
    name: "superscript"
  },
  operation: {
    name: "toggleSuperscript"
  }
});
var CodeControl = createControl({
  label: "codeControlLabel",
  icon: function icon(props) {
    return /* @__PURE__ */React.createElement(IconCode, __spreadProps(__spreadValues({}, props), {
      stroke: 1.5
    }));
  },
  isActive: {
    name: "code"
  },
  operation: {
    name: "toggleCode"
  }
});
var CodeBlockControl = createControl({
  label: "codeBlockControlLabel",
  icon: function icon(props) {
    return /* @__PURE__ */React.createElement(IconCode, __spreadProps(__spreadValues({}, props), {
      stroke: 1.5
    }));
  },
  isActive: {
    name: "codeBlock"
  },
  operation: {
    name: "toggleCodeBlock"
  }
});
var HighlightControl = createControl({
  label: "highlightControlLabel",
  icon: function icon(props) {
    return /* @__PURE__ */React.createElement(IconHighlight, __spreadProps(__spreadValues({}, props), {
      stroke: 1.5
    }));
  },
  isActive: {
    name: "highlight"
  },
  operation: {
    name: "toggleHighlight"
  }
});
var HrControl = createControl({
  label: "hrControlLabel",
  icon: function icon(props) {
    return /* @__PURE__ */React.createElement(IconLineDashed, __spreadProps(__spreadValues({}, props), {
      stroke: 1.5
    }));
  },
  operation: {
    name: "setHorizontalRule"
  }
});
var UnsetColorControl = createControl({
  label: "unsetColorControlLabel",
  icon: function icon(props) {
    return /* @__PURE__ */React.createElement(IconCircleOff, __spreadProps(__spreadValues({}, props), {
      stroke: 1.5
    }));
  },
  operation: {
    name: "unsetColor"
  }
});
export { AlignCenterControl, AlignJustifyControl, AlignLeftControl, AlignRightControl, BlockquoteControl, BoldControl, BulletListControl, ClearFormattingControl, CodeBlockControl, CodeControl, H1Control, H2Control, H3Control, H4Control, H5Control, H6Control, HighlightControl, HrControl, ItalicControl, OrderedListControl, StrikeThroughControl, SubscriptControl, SuperscriptControl, UnderlineControl, UnlinkControl, UnsetColorControl };